define("calendar/components/calendar/future-trends/try-modal", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Portal @destinationElement="root-portal">
    <Shared::Modal @close={{this.closeModal}} @focusTrap={{true}} as |modal|>
      <modal.card class="cCA--tryFutureTrends__modal">
        <modal.card-body class="cCA--tryFutureTrends__container">
          <img
            alt={{t "calendar.future_trends.modal.title"}}
            class="o--media cCA--tryFutureTrends__img"
            src="/assets/images/img--futureTrending--hashtags.png"
          />
          <div class="cCA--tryFutureTrends__content">
            <h2>
              {{t "calendar.future_trends.modal.title"}}
            </h2>
            <p class="u--text--base">
              {{t "calendar.future_trends.modal.description"}}
            </p>
            <Shared::Ui::Button
              @additional="rounded"
              @onClick={{this.closeModal}}
              @text={{t "calendar.future_trends.modal.button"}}
              @variant="primary"
              class="u--text--md u--text--bold cCA--tryFutureTrends__content__button"
            />
          </div>
        </modal.card-body>
      </modal.card>
    </Shared::Modal>
  </Shared::Portal>
  */
  {
    "id": "uYDSTkSy",
    "block": "[[[8,[39,0],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@close\",\"@focusTrap\"],[[30,0,[\"closeModal\"]],true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card\"]],[[24,0,\"cCA--tryFutureTrends__modal\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],[[24,0,\"cCA--tryFutureTrends__container\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"img\"],[15,\"alt\",[28,[37,2],[\"calendar.future_trends.modal.title\"],null]],[14,0,\"o--media cCA--tryFutureTrends__img\"],[14,\"src\",\"/assets/images/img--futureTrending--hashtags.png\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCA--tryFutureTrends__content\"],[12],[1,\"\\n          \"],[10,\"h2\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"calendar.future_trends.modal.title\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--text--base\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"calendar.future_trends.modal.description\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,3],[[24,0,\"u--text--md u--text--bold cCA--tryFutureTrends__content__button\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"rounded\",[30,0,[\"closeModal\"]],[28,[37,2],[\"calendar.future_trends.modal.button\"],null],\"primary\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]]]]]],[\"modal\"],false,[\"shared/portal\",\"shared/modal\",\"t\",\"shared/ui/button\"]]",
    "moduleName": "calendar/components/calendar/future-trends/try-modal.hbs",
    "isStrictMode": false
  });
  let TryFutureTrendsModalComponent = _exports.default = (_class = class TryFutureTrendsModalComponent extends _component2.default {
    closeModal() {
      this.args.closeModal();
      (0, _runloop.later)(() => {
        this.args.showFutureTrends();
      }, 100);
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TryFutureTrendsModalComponent);
});